import { useNavigate } from "react-router";
import AppWindow from "../helpers/app-window";

const appWindow = AppWindow();

export default function useHomePage() {
  const navigate = useNavigate();

  const goHome = () => {
    sessionStorage.removeItem("launch");
    if (sessionStorage.getItem("landingSubject")) {
      navigate("/liftoff");
    } else {
      window.location.replace(appWindow.STUDENT_ENV.REACT_APP_ALA_HOMEPAGE_RETURN_URL);
    }
  };

  return { goHome };
}
